/**
 * Ein Service, den JobCollections sammelt.
 * Wird für den Chart-Ausdruck verwendet.
 */
export class JobService {
    beforePrint = new JobCollection<any>();

    afterPrint = new JobCollection<any>();
}

/**
 * Ein Contener, der Job-Funktions sammelt. Jeder Job ist eine Funktion, die einen Fertig-Promise zurückliefert.
 */
export class JobCollection<T> {

    private jobs: ((i: T) => Promise<T>)[] = [];

    /**
     * @param {(i: T) => Promise<T>} listener nimmt ein T Argument
     * @returns {Function} Löschen-Funktion
     */
    add(listener: (i: T) => Promise<T>): () => any {
        const jobsCount = this.jobs.push(listener);
        const listenerIndex = jobsCount - 1;
        return () => this.jobs.splice(listenerIndex, 1);
    }

    /**
     * Liefert einen Promise zurück, der aufgelöst wird, sobald alle Jobs aufgelöst wurden.
     */
    emit(value?: T): Promise<any> {
        return Promise.all(
            this.jobs.map(l => l(value))
        );
    }
}
